<template>
  <div class="card bg-white border-0">
    <div class="card-header bg-white">
      <card-header :title="model.name" />
    </div>
    <div class="card-body p-3 px-2">
      <div class="row">
        <div class="col-5">
          <div class="row form-group">
            <div class="col-3">
              <label>Practice</label>
            </div>

            <div class="col" style="line-height: 1.75em">
              <b class="d-block">{{ model.name }}</b>
              <span class="d-block">{{ model.address }}</span>
              <!--<span v-if="model.address_2" class="d-block">{{model.address_2}}</span>-->
              {{ [model.city, model.state, model.zip].filter((s) => s).join(' ') }}
              <b class="d-block">{{ model.phone }}</b>
              <a v-if="model.email" class="d-block font-weight-bold" :href="'mailto:' + model.email">{{
                model.email
              }}</a>
              <a v-if="model.website" class="d-block font-weight-bold" :href="model.website" target="_blank">{{
                model.website
              }}</a>
            </div>
          </div>
          <div class="row form-group mb-0" v-if="model.npi && model.npi !== 'MANUAL_ADD'">
            <div class="col-3">
              <label>NPI</label>
            </div>

            <div class="col">{{ model.npi }}</div>
          </div>
          <div class="row form-group mb-0">
            <div class="col-3">
              <label>Type</label>
            </div>
            <div class="col">{{ PracticeTypes[model.specialty] }}</div>
          </div>
        </div>
        <div class="col">
          <div class="embed-responsive embed-responsive-1by1" v-if="model.address">
            <iframe
              class="embed-responsive-item"
              frameborder="0"
              style="border: 0"
              :src="embedMapLink"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PracticeApi } from '@/services'
import { mapGetters } from 'vuex'
export default {
  async created() {
    if (this.$route.params.id) {
      PracticeApi.get(this.$route.params.id).then((data) => {
        this.model = data
        // todo: either; global state (preferred), pass from top component or cache -
        // in theory we should always have this object in its entirety(need to confirm -
        // i.e.any extra detail fields like attachments)
      })
    }
    if (!this.$store.state.practices.isLoaded && !this.$store.state.practices.isLoading) {
      await this.$store.dispatch('practices/load')
    }
    this.$validator.localize({
      en: {
        attributes: {
          name: 'Practice Name',
        },
      },
    })
  },
  data() {
    return {
      isSubmitted: false,
      isError: false,
      isSubmitting: false,
      ajaxErrors: [],
      model: {
        id: null,
        name: '',
      },
    }
  },
  computed: {
    ...mapGetters('practices', ['network']),
    ...mapGetters('settings', ['PracticeTypes']),
    embedMapLink: function () {
      let q = encodeURIComponent(this.$helpers.address(this.model).trim())
      if (!q || !q.length) return ''
      return `https://www.google.com/maps/embed/v1/place?q=${q}&key=AIzaSyAtNYavBILab8TqUatQz6KoPr390jrCv9c`
    },
    isInNetwork() {
      return this.network.some((p) => p.id == this.$route.params.id)
    },
  },
}
</script>
